module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-sound_on@2x.png?0.0.53";